import { buildQuery } from "../lib/network";
import { coreService } from "../services/coreService";

export const fetchGetFeatureFlags = (headers: any) => {
  return (key: any, featureName: string) => {
    return buildQuery(coreService.featureFlagsDetail(featureName, { headers }), (response) => {
      return response.data;
    });
  };
};
